import { supabase } from '@/lib/supabase'
import type { Service, ServiceStatus } from '@/features/services/types'

export async function fetchServices(): Promise<Service[]> {
  const { data, error } = await supabase
    .from('services')
    .select('*')
    .order('updated_at', { ascending: false })

  if (error) {
    throw new Error(error.message)
  }

  return data ?? []
}

export async function createService(data: Partial<Service>): Promise<Service> {
  const { data: result, error } = await supabase
    .from('services')
    .insert([
      {
        ...data,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      },
    ])
    .select()
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return result
}

export async function updateService(id: string, data: Partial<Service>): Promise<Service> {
  const { data: result, error } = await supabase
    .from('services')
    .update({
      ...data,
      updated_at: new Date().toISOString(),
    })
    .eq('id', id)
    .select()
    .single()

  if (error) {
    throw new Error(error.message)
  }

  return result
}

export async function deleteService(id: string): Promise<void> {
  const { error } = await supabase.from('services').delete().eq('id', id)

  if (error) {
    throw new Error(error.message)
  }
}

export async function updateServiceStatus(id: string, status: ServiceStatus): Promise<void> {
  const { error } = await supabase
    .from('services')
    .update({
      status,
      updated_at: new Date().toISOString(),
    })
    .eq('id', id)

  if (error) {
    throw new Error(error.message)
  }
}
